import {AnalysisGraphQL} from 'analysis-tool/AnalysisTypes';
import getAdditionalDataFrameMetadataModalContent from 'analysis-tool/data-frame-metadata/getDataFrameMetadataModalContent';
import {DataViewContextValue} from 'analysis-tool/data-view/DataViewContext';
import {PipelineViewGraphQL} from 'pipelines/PipelineTypes';
import {isDataFrameView} from 'pipelines/PipelineViewUtils';

export default function getAdditionalMetadataContent(
  analysis: AnalysisGraphQL,
  view: PipelineViewGraphQL
): DataViewContextValue['additionalMetadataContent'] {
  if (isDataFrameView(view)) {
    return getAdditionalDataFrameMetadataModalContent(
      analysis.steps.find(({id}) => id === view.lineage[0].step.id)!
    );
  }

  return undefined;
}
